import { toast } from "sonner";
import api from "@/lib/api";

export async function downloadTemplate(slug, title) {
  try {
    const res = await api.get(`/templates/${slug}/download`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `${slug.replace(/-/g, "_")}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success(`Downloaded "${title}"`);
    return true;
  } catch (err) {
    if (err.response?.status === 403) toast.error("Unlock this part to download the template.");
    else toast.error("Download failed. Please try again.");
    return false;
  }
}
